import {
	type NavigateNotificationRequest,
	type RpcMessage,
	WebViewMessageTypes,
} from "web_myplann/Utils/WebViewModel";

const handledNavigationMessageIds = new Set<string>();

export const getMessageId = (message: NavigateNotificationRequest) =>
	(message as Partial<RpcMessage<NavigateNotificationRequest>>).messageId;

export const sendReceipt = (messageId: string) => {
	window.ReactNativeWebView?.postMessage(
		JSON.stringify({
			type: WebViewMessageTypes.NAVIGATE_NOTIFICATION_RESPONSE,
			payload: { received: true },
			messageId,
		}),
	);
};

export const isDuplicate = (messageId: string) => {
	if (handledNavigationMessageIds.has(messageId)) {
		return true;
	}
	handledNavigationMessageIds.add(messageId);
	return false;
};
